
let host = '';
let url = '';

if (process.env.REACT_PUBLIC_ENVIROMENT === 'localhost') {
    host = 'http://localhost:8080';
    url = 'http://localhost:3000';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'SIT1') {
    host = 'https://sit1-apiemployer-themoodspaceconnect.innov.co.in';
    url = 'https://sit1-uiemployer-themoodspaceconnect.innov.co.in';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'UAT1') {
    host = 'https://uat1-apiemployer-themoodspaceconnect.innov.co.in';
    url = 'https://uat1-uiemployer-themoodspaceconnect.innov.co.in';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'Production') {
    host = 'https://employerapi.themoodspace.com';
    url = 'https://employer.themoodspace.com';
}


export const domain = host;
export const websiteUrl = url;
export const basicAuth = 'dG1zZW1wbG95ZXI6JDJhJDEyJFM1RzFLLy9xcUdDU0dic0pxdC5FdE8uWEk2OWVXcGdBUzYvMEJUMkJxNzFsTVcuczMvU0ZX';//'dG1zYWRtaW46dG1zQDEyMzQ1=';
export const storageTokenKeyName = 'accessToken';
export const temporaryStorageTokenKeyName = 'temporaryToken';


